import { useState } from "react";
import type { WidgetKind } from "@playbookai/types";
import { getWidget } from "../widgets/registry.js";
import { WidgetErrorBoundary } from "./entity-dashboard/WidgetErrorBoundary.js";

const ignoreChange = () => undefined;

/** Reuse the registered, schema-validated widget body without any persistence adapter. */
export function WidgetProposalSnapshot({
  kind,
  data,
}: {
  kind: string;
  data: unknown;
}) {
  const [open, setOpen] = useState(false);
  const def = getWidget(kind as WidgetKind);
  if (!def || def.storage !== "sql") return null;
  const parsed = def.schema.safeParse(data);
  if (!parsed.success) return null;
  const Body = def.Component;
  return (
    <details
      onToggle={(event) => setOpen(event.currentTarget.open)}
      className="rounded-md border border-pb-border bg-pb-card"
    >
      <summary className="cursor-pointer rounded-md px-3 py-2 font-medium text-pb-text focus-visible:outline focus-visible:outline-2 focus-visible:outline-pb-teal">
        Widget preview
      </summary>
      {open && (
        // Chat's anywhere wrapping must not collapse a widget's table columns.
        // `relative`: a widget's absolutely positioned parts anchor (and clip)
        // to this box, as they do to their canvas frame, instead of escaping
        // into the thread (PB-5381).
        <div className="relative flex h-80 min-w-0 flex-col overflow-auto whitespace-normal break-normal border-t border-pb-border p-3 [&_th]:whitespace-nowrap [&_.recharts-surface]:overflow-visible">
          <WidgetErrorBoundary
            widgetName="Widget preview"
            resetKeys={[kind, data]}
            fallbackSlot={
              <p>
                The widget preview could not be displayed. Review the saved
                content below.
              </p>
            }
          >
            <Body data={parsed.data} readOnly onChange={ignoreChange} />
          </WidgetErrorBoundary>
        </div>
      )}
    </details>
  );
}
